
import './App.css';
import Viewer2D from './Components/2DViewer';
import TablesMenu from './Components/TablesMenu';
import ChairsMenu from './Components/ChairsMenu';
import SizeMenu from './Components/SizeMenu';
import { useEffect, useRef, useState, useLayoutEffect } from 'react';
import { chairs, tables,sizes } from './Components/Data';

function App() {

  const viewer3DElementRef = useRef()

  const [currentTable, setCurrentTable] = useState(tables[0])
  const [currentChairs, setCurrentChairs] = useState(chairs[0])
  const [currentSize, setCurrentSize] = useState(sizes[0])


  const [viewer, setViewer] = useState(true)

  const [loading, setLoading] = useState(false)

  function getParams() {
    const url = new URL(window.location.href);

    // Create a URLSearchParams object
    const params = new URLSearchParams(url.search);

    // Get the value of specific parameters
    const table = params.get('currentTable');
    const chair = params.get('currentChairs')
    const autoStartReq = params.get('autoStart')
    if (table != null && chair != null) {
      setCurrentTable(tables[table])
      setCurrentChairs(chairs[chair])
    }

  }

  useEffect(() => {
    setTimeout(() => {
      getParams()
    }, 1000);



  }, [])

  function startLoading() {
    setLoading(true)
  }

  function stopLoading() {
    setLoading(false)
  }



  const switchTable = (table) => {
    setCurrentTable(table)
  }


  const switchChairs = (chair) => {
    setCurrentChairs(chair)
  }

  const switchSize = (size) => {
    setCurrentSize(size)
  }


  return (


    <div className="app-root flex flex-col md:flex-row h-screen">
      <div className="viewer-3d flex flex-col w-full md:w-2/3 h-1/2 md:h-full bg-gray-100">
        <div className="viewer-area flex-grow h-[100%] overflow-hidden relative" ref={viewer3DElementRef}>
          {loading && <div className="loading-animation">Loading...</div>}
          <div style={{ display: viewer ? "block" : "none" }}>
            <Viewer2D image={`${currentTable.id}-${currentSize.id}-${currentChairs.id}.jpg`} />
          </div>
        </div>
      </div>

      <div className="selection-menu flex flex-col w-full md:w-1/3 h-1/2 md:h-[100%]">
        <div className="menu flex-grow flex p-0 box-border">
          <TablesMenu switchTable={switchTable} currentTable={currentTable} />
        </div>
        <div className="menu flex-grow p-0 box-border">
          <SizeMenu switchSize={switchSize} currentSize={currentSize} />
        </div>
        <div className="menu flex-grow p-0 box-border md:px-1 md:py-1">
          <ChairsMenu switchChairs={switchChairs} currentChairs={currentChairs} />
        </div>
        {/* <div className='add-to-cart-button'>Add Selection To Cart</div> */}
      </div>
    </div>






  );
}

export default App;
